import React, { memo } from 'react';
import { HeaderTypeTokens, SizeTypeTokens, } from '@voltmoney/schema';
import BankHeaderBase from './BankHeader.Base';
import ThemeProvider from '@voltmoney/theme';
import { VerificationHeaderBase } from './VerificationHeader';
import HeaderDefaultBase from './HeaderDefault.Base';
import HeaderCtaBase from './HeaderCta.base';
import { HeaderPartnerBase } from './HeaderPartner.base';
const Header = ({ type = HeaderTypeTokens.header, id, ...props }) => {
    const theme = ThemeProvider.getTheme();
    const headerThemeProps = theme.header[type];
    switch (type) {
        case HeaderTypeTokens.header:
            return (React.createElement(BankHeaderBase, { ...headerThemeProps, ...props, padding: SizeTypeTokens.SM }));
        case HeaderTypeTokens.verification:
            return (React.createElement(VerificationHeaderBase, { id: id, ...headerThemeProps, ...props, padding: SizeTypeTokens.SM }));
        case HeaderTypeTokens.DEFAULT:
            return (React.createElement(HeaderDefaultBase, { id: id, ...headerThemeProps, ...props, padding: SizeTypeTokens.SM }));
        case HeaderTypeTokens.HEADERCTA:
            return (React.createElement(HeaderCtaBase, { id: id, ...headerThemeProps, ...props, padding: SizeTypeTokens.SM }));
        case HeaderTypeTokens.PARTNER:
            return (React.createElement(HeaderPartnerBase, { ...headerThemeProps, ...props, padding: SizeTypeTokens.SM }));
        default:
            return React.createElement(React.Fragment, null);
    }
};
export default memo(Header);
export { Header };
